import { render, staticRenderFns } from "./Tags.vue?vue&type=template&id=ba87b160&scoped=true"
import script from "@/views/Settings/Tags/Tags.ts?vue&type=script&lang=ts&external"
export * from "@/views/Settings/Tags/Tags.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Settings/Tags/tags.scss?vue&type=style&index=0&id=ba87b160&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba87b160",
  null
  
)

export default component.exports